<template>
  <div>
    <!-- <div>{{JSON.stringify(serviceModel)}}</div>
    <div>{{JSON.stringify(categoryModel)}}</div>
    <div>{{JSON.stringify(infoModel)}}</div>
    <div>{{JSON.stringify(certificateModel)}}</div> -->
    <customFormCommonService v-model="serviceModel" @refresh="send"></customFormCommonService>
    <customFormCommonCategory v-model="categoryModel" @refresh="send"></customFormCommonCategory>
    <customFormCommonInfo v-model="infoModel" @refresh="send"></customFormCommonInfo>
    <!-- <customFormCommonCertificate v-model="certificateModel" @refresh="send"></customFormCommonCertificate> -->
  </div>
</template>

<script>
import customFormCommonService from "@/components/customForm/common/custom-form-common-service/custom-form-common-service.vue";
import customFormCommonCategory from "@/components/customForm/common/custom-form-common-category/custom-form-common-category.vue";
import customFormCommonInfo from "@/components/customForm/common/custom-form-common-info/custom-form-common-info.vue";
// import customFormCommonCertificate from "@/components/customForm/common/custom-form-common-certificate/custom-form-common-certificate.vue";
import { mapGetters } from "vuex";
export default {
  // 领域类别： 品牌商
  name: "custom-form-factory",
  props: { 
    field: {
      type: Object,
      default: { extend: [], properties: [] }
    }
  }, 
  data() {
    return {
      propertyArr: [
        { List: [], TypeId: 0, Value: "授权渠道" },
        { List: [], TypeId: 1, Value: "招募地区" },
        { List: [], TypeId: 2, Value: "服务范围" },
        { List: [], TypeId: 3, Value: "代工品类" },
        { List: [], TypeId: 4, Value: "擅长内容" },
        { List: [], TypeId: 5, Value: "合作渠道" },
        { List: [], TypeId: 6, Value: "放大" },
        { List: [], TypeId: 11, Value: "合作客户" }
      ],
      serviceModel: { List: [], TypeId: 2, Value: "服务范围" },
      categoryModel: { List: [], TypeId: 3, Value: "代工品类" },
      infoModel: { List: [], TypeId: 6 },
      certificateModel: { List: [], TypeId: 11 }
    };
  },
  components: {
    customFormCommonService,
    customFormCommonCategory,
    customFormCommonInfo,
    // customFormCommonCertificate
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    })
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let data = this.field.properties; 
      let extend = this.field.extend;
      if (!data) return; 
      data.forEach(c => {
        if (c.TypeId === 1) {
          this.serviceModel.List = c.List;
        }
        if (c.TypeId === 3) {
          this.categoryModel.List = c.List; 
        }
      }); 
      if (extend && extend.length) { 
        extend.forEach(c => {
          if (c && c.TypeId === 6) {
            this.infoModel.List = c.List; 
          }
        });
        console.log("serviceModel: ", this.serviceModel);
        console.log("categoryModel: ", this.categoryModel);
        console.log("infoModel: ", this.infoModel);
        console.log("certificateModel: ", this.certificateModel);
        return;
      }
    },
    send() {
      let model = [];
      let extend = null;
      if (this.serviceModel && this.serviceModel.List.length) {
        model.push(this.serviceModel);
      }
      if (this.categoryModel && this.categoryModel.List.length) {
        model.push(this.categoryModel);
      }  
      if (this.infoModel && this.infoModel.List && this.infoModel.List.length) {
        extend = this.infoModel;
      }  
      this.$emit("change", { extend: [extend], properties: model });
    }
  }
};
</script>

<style scoped lang="scss">
</style>
